import React from 'react';
import { sanitizeHTML } from '../utils/htmlSanitizer';

interface HTMLContentProps {
  content: string;
  onInternalNavigate: (path: string) => void;
  className?: string;
}

const HTMLContent: React.FC<HTMLContentProps> = ({ content, className, onInternalNavigate }) => {

  const contentClickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    const targetLink = (e.target as HTMLElement).closest('a');
    if (!targetLink?.href) {
      return;
    }

    const linkUrl = new URL(targetLink.href, window.location.origin);
    const isInternal = linkUrl.origin === window.location.origin;

    if (isInternal) {
      e.preventDefault();
      onInternalNavigate(linkUrl.pathname + linkUrl.search + linkUrl.hash);
    }
  };

  return (
      <div
          className={className}
          onClick={contentClickHandler}
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(content) }}
      />
  );
};

export default HTMLContent;